const Header = () => {
  return (
    <div
      className="container"
      style={{
        paddingTop: "1em",
        fontFamily: "'Open Sans', sans-serif",
      }}
    >
      <h4 style={{ textAlign: "center", fontWeight: "400" }}>
        Movies Now Playing in Indonesia 🇮🇩
      </h4>
    </div>
  );
};

export default Header;
